module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 6h-9.172l2.586-2.586c.782-.782.782-2.046 0-2.828s-2.046-.782-2.828 0L16 5.172 11.414.586c-.782-.782-2.046-.782-2.828 0s-.782 2.046 0 2.828L11.172 6H2C.894 6 0 6.894 0 8v22c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V8c0-1.106-.894-2-2-2zm-6 21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16zm6-8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm0-6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/tv-1.js
// module id = 1463
// module chunks = 14